import { render, staticRenderFns } from "./NormalSearchNav234.vue?vue&type=template&id=1edc13bf&scoped=true"
import script from "./NormalSearchNav234.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav234.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc13bf",
  null
  
)

export default component.exports